import { List, Map } from 'immutable';

// https://stackoverflow.com/questions/18749591/encode-html-entities-in-javascript
function htmlEncode(input) {
  return input.replace(/[\u00A0-\u9999<>&]/g, function (i) {
    return '&#' + i.charCodeAt(0) + ';';
  });
}
export function convertFITBtoRich(interactionTypeData, richFITBInteractionID) {
  var interactionData = interactionTypeData.interactionData,
    scoringData = interactionTypeData.scoringData;
  var sortedStemItems = interactionData.get('stemItems').sort(function (a, b) {
    return a.get('position') - b.get('position');
  });
  var workingItemBody = sortedStemItems.reduce(function (itemBody, stemItem) {
    if (stemItem.get('type') === 'text') {
      return itemBody + htmlEncode(stemItem.get('value', ''));
    } else {
      var blankScoringData = scoringData.get('value', List()).find(function (blank) {
        return blank.get('id') === stemItem.get('blankId');
      }) || Map();
      var blankText = blankScoringData.getIn(['scoringData', 'blankText'], '');
      return itemBody + "`".concat(htmlEncode(blankText), "`");
    }
  }, '');
  return Object.assign({}, interactionTypeData, {
    id: richFITBInteractionID,
    itemBody: '',
    interactionData: {
      blanks: interactionData.get('blanks', [])
    },
    scoringData: {
      workingItemBody: "".concat(interactionData.get('prompt', ''), "<p>").concat(workingItemBody, "</p>"),
      value: scoringData.get('value', [])
    }
  });
}